// 初回ヒアリング: 動的質問定義 (要件 §7-2)
// 2026-06-25: マイページ会員情報の10項目に統一 (docs/plans/cfl-hearing-profile-unify.md)。
// hearing_questions(DB) が正、本定数は migrate 前/空のときのフォールバック。
// ※ label はコミュニティごとの**データ**であり、正本は DB (管理画面 > ヒアリング設計)。
//    ここの文言は CFL の初期値で、migrate 済みの環境では一度も表示されない。
//    別コミュニティで文言を変えるときは、この定数ではなく管理画面から直すこと。
// annual_revenue_band / employee_band の options は MyPageProfileEdit も参照する。
import type { HearingQuestionDTO } from "./dto";

export const HEARING_QUESTIONS_VERSION = 3;

export const HEARING_QUESTIONS: HearingQuestionDTO[] = [
  { code: "company_name",         label: "法人名",                  type: "text",     required: false, sortOrder: 10 },
  { code: "display_name",         label: "参加者名",                type: "text",     required: true,  sortOrder: 20 },
  { code: "address",              label: "所在地",                  type: "text",     required: false, sortOrder: 30 },
  { code: "phone",                label: "電話番号",                type: "text",     required: false, sortOrder: 40 },
  { code: "business_description", label: "事業内容",                type: "textarea", required: false, sortOrder: 50 },
  { code: "annual_revenue_band",  label: "年商規模",                type: "select",   required: false, sortOrder: 60,
    options: [
      { value: "lt_10m",       label: "1000万円未満" },
      { value: "10m_50m",      label: "1000万〜5000万円未満" },
      { value: "50m_100m",     label: "5000万〜1億円未満" },
      { value: "100m_500m",    label: "1億〜5億円未満" },
      { value: "500m_1b",      label: "5億〜10億円未満" },
      { value: "1b_3b",        label: "10億〜30億円未満" },
      { value: "3b_10b",       label: "30億〜100億円未満" },
      { value: "gte_10b",      label: "100億円以上" },
    ],
  },
  { code: "employee_band",        label: "従業員数 / 業務委託人数", type: "select",   required: false, sortOrder: 70,
    options: [
      { value: "1",        label: "1名" },
      { value: "2_5",      label: "2〜5名" },
      { value: "6_20",     label: "6〜20名" },
      { value: "21_50",    label: "21〜50名" },
      { value: "51_100",   label: "51〜100名" },
      { value: "101_200",  label: "101〜200名" },
      { value: "201_500",  label: "201〜500名" },
      { value: "gte_500",  label: "501名以上" },
    ],
  },
  { code: "challenges_text",      label: "解決したい課題",          type: "textarea", required: false, sortOrder: 80 },
  { code: "support_needs_text",   label: "CFLに求める事",           type: "textarea", required: false, sortOrder: 90 },
];
